export default __webpack_public_path__ + "static/media/InfectionRisk.ce6e60b5.svg";